
    import {
        defineComponent, PropType,
    } from 'vue';
    import DialogWrapperDesktop from '@ve/components/dialogWrapper/desktop/DialogWrapperDesktop.vue';
    import useRailwayToursListPopup from '../common/useRailwayToursListPopup';
    import { IRailwayToursListItem } from '../common/types';
    import RailwayTourItem from './RailwayTourItem.vue';

    export default defineComponent({
        name: 'railway-tours-list-popup',
        components: {
            DialogWrapperDesktop,
            RailwayTourItem,
        },
        props: {
            railwayTourItems: {
                type: Array as PropType<IRailwayToursListItem[]>,
                required: true,
            },
        },
        setup(props, ctx) {
            const {
                railwayTourSelected,
                railwayToursListPopup,
                open,
                close,
                selectRailwayTour,
            } = useRailwayToursListPopup();

            return {
                open,
                close,
                railwayToursListPopup,
                railwayTourSelected,
                selectRailwayTour,
            };
        },
    });
